import React, { useState } from 'react';

import { Button } from '@spark';

import { WaitlistLogo } from './WaitlistLayout';

export const WAITLIST_DONE_TITLE = 'We Got Your Request!';
export const WAITLIST_DONE_BODY =
    "You're officially on the list! \n\nWe have successfully received your details and secured your spot on the waitlist for SpecificAI.\n\n";

/**
 * "We Got Your Request!" confirmation (Figma MVP-DESIGNES 9220:4231).
 *
 * The only waiting-list screen set in Inter Light, hence the feature-scoped
 * `waitlist-inter-light-*` classes instead of Spark `<Text>` variants.
 * `onReturn` is awaited so the caller can sign the applicant out before
 * routing back to `/login`.
 */
export default function WaitlistDone({ onReturn }) {
    const [busy, setBusy] = useState(false);

    const handleReturn = async () => {
        if (busy) return;
        setBusy(true);
        try {
            await onReturn?.();
        } finally {
            setBusy(false);
        }
    };

    return (
        <>
            <WaitlistLogo size="small" />
            <h1 className="waitlist-done-title waitlist-inter-light-36">{WAITLIST_DONE_TITLE}</h1>
            <p className="waitlist-done-body waitlist-inter-light-24">{WAITLIST_DONE_BODY}</p>
            <div className="waitlist-done-footer">
                <Button size="large" variant="primary" disabled={busy} onClick={handleReturn}>
                    Return to Specific Website
                </Button>
            </div>
        </>
    );
}
